import React, { useState , useRef } from "react";
import "./Roof_waterproofing_bituminous_sheets.css";
import { Link } from "react-router-dom";
import ContactSection2 from '../Category/ContactSection2';
import Adsense from "../Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)
import InArticleAd from "../InArticleAd"; // 🔥 ייבוא המודעה החדשה לגוף המאמר

export default function Roof_waterproofing_bituminous_sheets() {


  return (

    <div className="Roof_waterproofing_bituminous_sheets-page">
      <div className="Roof_waterproofing_bituminous_sheets-hero">
        <div className="Roof_waterproofing_bituminous_sheets-overlay">
          <h1>   איטום גגות - יריעות ביטומניות</h1>
        </div>
<div>
</div>
</div>
    <div className="page6">
 <div className="breadcrumb6">
  <Link to="/">בית</Link> /{" "}
  <Link to="/OurServices"> השירותים שלנו </Link>/{" "}
   <Link to="/Roof_waterproofing_bituminous_sheets">     איטום גגות - יריעות ביטומניות </Link>{" "}
</div>
    </div>
        <div className="video-line" />
<div className="video-box2">
  <iframe
    width="100%"
    height="400"
    src="https://www.youtube.com/embed/vGiYZAfh5a0?start=11"
    title="YouTube video"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowFullScreen
  ></iframe>
</div>
      {/* CONTENT */}
<div className="page6">
  <div className="container">

    <div className="content-row2">


      <div className="image-box2">
        <img src="/images/70.jpeg" alt="roof" />
      </div>
      <div className="text-box">
        <p>  
איטום הגג הוא הדבר הראשון והחשוב ביותר שצריך לבדוק ולבצע כאשר נכנסים לדירה חדשה בקומה עליונה.

</p>

       <p>  
כשאיטום הגג תקין אנו יכולים להיות שקטים ורגועים, מומלץ לאטום את הגג ביריעות ביטומניות כיוון שהוא חומר האיטום האיכותי והנפוץ ביותר לאיטום גגות , איטום מרפסות, איטום מרתפים ועוד.
</p>


       <p>  
היריעות מבוססות על "ביטומן", מוצר תרמופלסטי המתרכך בחום שהינו תוצר זיקוק של הנפט הגולמי ומשובח בפולימרים תרמופלסטיים.
</p>
       <p>  
היריעות מבוססות על "ביטומן", מוצר תרמופלסטי המתרכך בחום שהינו תוצר זיקוק של הנפט הגולמי ומשובח בפולימרים תרמופלסטיים.
</p>

  <h2 className="info-title">   היריעות קיימות בסוגים שונים -</h2>

  <ul className="info-list">
    <li>SBS או APP</li>
    <li>יריעה שחורה או יריעה לבנה</li>
    <li>בעובי של 4-5 מ״מ</li>
  </ul>

       <p>  
היריעות משורינות בלבד פוליאסטר המקנה ליריעות חוזק וגמישות גבוהים הרבה מעבר לרוב חומרי האיטום שקיימים ולכן יריעות הוא המוצר האיכותי והנפוץ ביותר לביצוע עבודות איטום.</p>


      </div>

    </div>




    <ContactSection2/>
<div className="links2">


  <Link to="/Cleaning_windows_and_buildings_in_abseiling" className="link-right" > ניקיון חלונות ומבנים בסנפלינג</Link>
  <Link to="/Roof_tar_and_plastering" className="link-left" > זיפות וסיוד גגות</Link>


</div>

      </div>
    </div>
  

      </div>
  );
}


